import {connect} from "react-redux";

import Checkout from "../../../../../components/Modals/OfferModal/Stripe/Offer350/Checkout/Checkout";
import {checkPromotionCode, setPromotionCode} from "../../../../../actions/stripePayment";
import {setErrorMessage, setResetUserInfos} from "../../../../../actions/user";
import {setShowOfferModal} from "../../../../../actions/modal";

const MapStateToProps = (state) => ({
customerId: state.stripePayment.customerId,
offerPrice: state.stripePayment.offerPrice,
percentOff: state.stripePayment.percentOff,
amountOff: state.stripePayment.amountOff,
promotionCode: state.stripePayment.promotionCode,
userInfos: state.stripePayment.userInfos,
activationCodeFlag: state.stripePayment.activationCodeFlag,
dataUser: state.user.dataUser,
});

const MapDispatchToProps = (dispatch) => ({
setPromotionCode: (code) => {
dispatch(setPromotionCode(code));
},
checkPromotionCode: () => {
dispatch(checkPromotionCode());
},
setErrorMessage: (msg) => {
dispatch(setErrorMessage(msg));
},
setShowOfferModal: (bool) => {
dispatch(setShowOfferModal(bool));
},
setResetUserInfos: (bool) => {
dispatch(setResetUserInfos(bool));
}
});

export default connect(MapStateToProps, MapDispatchToProps)(Checkout);